import { message } from 'antd';
import axios from 'axios';
import { AUTH_TOKEN } from '../redux/constant';
import { toastMessage } from '../utils/Utils';
import { BASE_URL } from './constant';
import { getEnvs } from '../utils/environments';

export const REACT_BASE_URL =
  getEnvs().REACT_APP_API_URL ?? window.location.origin;

export const MICROSERVICE_EVENT_PREFIX = '/events';

function getBaseRoot() {
  // return BASE_URL
  // return (
  //    `http://${window.location.hostname}:3020`
  //   )
  return REACT_BASE_URL;
  // return 'http://demo.farscada.ir:3020'
}

export const baseRoot = getBaseRoot();
axios.defaults.baseURL = `${baseRoot}/api/v2/`;
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem(
  AUTH_TOKEN,
)}`;

axios.interceptors.request.use(
  function (req) {
    return req;
  },
  function (error) {
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  function (res) {
    return res;
  },
  function (error) {
    console.log('error >>>>>>', error);
    message.error(
      toastMessage(
        error.response?.data?.message || 'something went wrong!',
        'red',
      ),
    );
    if (error.response.status == 401) {
      localStorage.clear();
      window.location.href = '/auth/login';
    }
    return Promise.reject(error);
  },
);

export const MAX_POWER = (id) => `/getMaxPower/${id}`;

export const ALARMS = `/emergencyAlarms`;
export const INVERTER = `/reports/deviceValues`;
export const VALUE_MEASURE6 = `/reports/energies`;
export const VALUE_MEASURE6_LATEST = `/inverter/realTime-baset6/latest`;
export const VALUE_CONSUMPTION = `/inverter/realTime-baset6/consumption`;
export const DAILY_DATA = `/inverter/getValueParam_day`;
export const WEEKLY_DATA = `/inverter/getValueParam_week`;
export const MONTHLY_DATA = `/inverter/getValueParam_month`;
export const YEARLY_DATA = `/inverter/getValueParam_year`;
export const FIRST_VALUE_YEAR = `/inverter/getFirstValueYear`;
export const EVENT_LOG_LATEST = `/event/log/latest`;
export const EVENT_DESCRIPTION = `/event/desc`;

export const INVERTER_SEARCH = `/equipments/categories/blocks`;
export const INVERTER_STATUS = (equipmentId) =>
  `/equipments/categories/${equipmentId}`;
export const INVERTER_GET_PARAMS = (equipmentId) =>
  `/equipments/${equipmentId}`;

export const LOGIN = '/auth/login';

export const USER = '/users';
export const USER_ID = (id) => `/users/${id}`;
export const ANALYS = '/equipments/categories';

export const GET_EQ_PARAMS = (id) => `/parameter/categories/${id}`;
export const GET_EQ_NAMES_BLOCK = (block) =>
  `/analysis/getEqNames-block/${block}`;
export const GET_EQ_NAMES = (id) => `/equipments/categories/${id}`;

export const RETRIEVE_EQ_PA_VALUES = '/reports/equipmentParameterValues/v2';
export const RETRIEVE_EQ_PA_VALUES_V3 = '/reports/equipmentParameterValues/v3';

// export const LATEST_ENERGIES = '/reports/energies/latest';
export const LATEST_ENERGIES = '/analysis/measurement/energies/latest';

export const GET_EQ_PARAMS_BY_ID = (id) => `/parameter/equipments/${id}`;
// {"serial":"a","requestType":1,"selectedBlock":"BLOCK01","title":"b","block":"w","device":"z"}
